/* eslint-disable no-param-reassign */
import { useEffect, useState } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};
const transactionService = {
  _merchantToolUrl: `${process.env.REACT_APP_COMMON_API_URL}/merchant-tool`,
  GetReportDetails(id, year, month) {
    const [report, setReport] = useState({});
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.viewReport(id, year, month))
        .then(res => {
          setReport(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [id, year, month]);
    return {
      report_loading: status === STATUS.LOADING,
      report_error: status === STATUS.ERROR ? status : '',
      report_data: report,
    };
  },
  GetReportDetailsNew(mid, year, month) {
    const [report, setReport] = useState({});
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.viewReportNew(mid, year, month))
        .then(res => {
          setReport(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [mid, year, month]);
    return {
      report_new_loading: status === STATUS.LOADING,
      report_error: status === STATUS.ERROR ? status : '',
      report_new: report,
    };
  },
  async viewReport(id, year, month) {
    const res = await Fetch.get(`${this._merchantToolUrl}/statement/${id}?year=${year}&month=${month}`);
    if (res.status >= 200 && res.status < 300) {
      const data = await res.json();
      return data;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async viewReportNew(mid, year, month) {
    const res = await Fetch.get(`${this._merchantToolUrl}/statements/${mid}?year=${year}&month=${month}`);
    if (res.status >= 200 && res.status < 300) {
      const data = await res.json();
      return data;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
};
export default transactionService;
